const OccupationalHealthPolicy = () => {
  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */} 
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              Occupational Health  <span className="text-yellow-400">Policy</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          
          </div>
        </div>
    </div>


{/* Content Section */} 
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-6 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed font-bold relative z-10 italic">
          BEDC Electricity PLC is committed to ensuring the health and well-being of employees, visitors and contractors by providing a safe workplace.
          </p>
          <p className="mt-3 text-gray-400 font-medium text-xs sm:text-sm relative z-10 leading-relaxed">
            Our goal is to eliminate hazards that could result in injury or disease and implementing initiatives to improve overall staff welfare.
          </p>
        </div>

        <div className="bg-white rounded-xl md:rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-4 sm:p-6 md:p-8 text-black">
            <h2 className="text-lg sm:text-xl md:text-2xl font-black text-black mb-6 uppercase tracking-tighter">
              Health & <span className="text-green-700">Safety Standards</span>
            </h2>

            <div className="grid grid-cols-1 gap-6 mb-6">
              <div className="space-y-4">
                <p className="text-xs sm:text-sm md:text-base leading-relaxed font-medium text-gray-600">
                  This policy assists in eliminating hazards, health and safety
                  risks within and around our operational areas. All processes and
                  operations shall comply with relevant statutory requirements.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                  <div className="p-4 sm:p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-green-700 transition-all group">
                    <h4 className="text-[11px] sm:text-xs font-black text-green-700 uppercase tracking-widest mb-2">Employee Participation</h4>
                    <p className="text-black font-bold text-xs sm:text-sm leading-relaxed">
                      All employees are encouraged to participate in developing and enforcing HSE policies. Safety must never be sacrificed for speed.
                    </p>
                  </div>
                  <div className="p-4 sm:p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-green-700 transition-all group">
                    <h4 className="text-[11px] sm:text-xs font-black text-green-700 uppercase tracking-widest mb-2">Operational Compliance</h4>
                    <p className="text-black font-bold text-xs sm:text-sm leading-relaxed">
                      Occupational Health & Safety is the responsibility of every employee, customer, supplier and service provider.
                    </p>
                  </div>
                </div>
              </div>

              <div className="relative rounded-xl overflow-hidden shadow-xl border-4 border-white ring-1 ring-gray-100 transform hover:scale-[1.01] transition-transform duration-500">
                <img
                  src="/images/background-7.jpg"
                  alt="BEDC Safety Ops"
                  className="w-full h-auto object-cover max-h-[350px]"
                />
              </div>
            </div>

            <div className="bg-black text-white p-6 sm:p-8 rounded-xl md:rounded-2xl shadow-xl relative overflow-hidden group">
              <div className="absolute inset-0 bg-green-700/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
              <div className="relative z-10">
                <span className="text-yellow-400 font-black uppercase text-[10px] sm:text-xs tracking-[0.2em] mb-2 block">HSE Commitment</span>
                <h2 className="text-xl sm:text-2xl md:text-3xl font-black mb-4 uppercase tracking-tighter">
                  Building Safer <span className="text-green-700 block">Environments</span>
                </h2>
                <div className="w-16 h-1.5 bg-yellow-400 rounded-full mb-4"></div>
                <p className="text-xs sm:text-sm md:text-base text-gray-300 font-medium leading-relaxed max-w-3xl">
                  BEDC is committed to building safe environments and
                  eco-friendly solutions while fostering strong relationships
                  across all communities we serve.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OccupationalHealthPolicy;